import script from "./filterTag.vue?vue&type=script&setup=true&lang=js"
export * from "./filterTag.vue?vue&type=script&setup=true&lang=js"

import "./filterTag.vue?vue&type=style&index=0&id=6e6e9c5e&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e6e9c5e"]])

export default __exports__